import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, RouterStateSnapshot } from "@angular/router";
import { Observable, of } from "rxjs";
import { take, catchError, map } from "rxjs/operators";

import { ignoreNil } from "@triparound/trp-components/shared";

import { AuthenticationFacadeService } from "./authentication-facade.service";

@Injectable()
export class AuthenticationGuard {
	isGuestValidationActive$: Observable<boolean>;

	constructor(private authenticationFacade: AuthenticationFacadeService) {
		this.isGuestValidationActive$ = this.authenticationFacade.isGuestValidationActive$;
	}

	canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
		return this.isGuestValidationActive$.pipe(
			ignoreNil(),
			take(1),
			map(isGuestValidationActive => {
				if (isGuestValidationActive) {
					if (this.authenticationFacade.isUserValidated(route.params["customerUuid"])) {
						return true;
					}
					this.authenticationFacade.logout(state.url);
					return false;
				}
				return true;
			}),
			catchError(() => {
				this.authenticationFacade.logout(state.url);
				return of(false);
			}),
		);
	}
}
